import { render, staticRenderFns } from "./OperaXyLoginWindow.vue?vue&type=template&id=1895b54f&"
import script from "./OperaXyLoginWindow.vue?vue&type=script&lang=js&"
export * from "./OperaXyLoginWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports